/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaHoodComponents = [
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withAlias('LynxSedonaHood').attach(memoEval((self)=>[
            self.$offsetX
        ], ($offsetX)=>({
            offsetX: $offsetX
        })))
];

//# sourceMappingURL=lynx-sedona-hood.js.map